import React, { useState } from "react";
import { NavLink } from "react-router-dom";

const PortfolioCategories = () => {

    const [active, setActive] = useState("All");

    const categories = [
        "All",
        "iOS Apps",
        "Android Apps",

        "E-Commerce",
        "Healthcare",
    ];

   const projects = [
    {
        id: 1,
        slug: "food-delivery",
        title: "Food Delivery",
        category: "iOS Apps",
        image:
            "https://images.unsplash.com/photo-1551650975-87deedd944c3?q=80&w=1200&auto=format&fit=crop",
    },
    {
        id: 2,
        slug: "fitness-tracker",
        title: "Fitness Tracker",
        category: "Android Apps",
        image:
            "https://images.unsplash.com/photo-1576678927484-cc907957088c?q=80&w=1200&auto=format&fit=crop",
    },
    {
        id: 3,
        slug: "shopping-app",
        title: "Shopping App",
        category: "E-Commerce",
        image:
            "https://images.unsplash.com/photo-1563013544-824ae1b704d3?q=80&w=1200&auto=format&fit=crop",
    },
];

    const filteredProjects =
        active === "All"
            ? projects
            : projects.filter((item) => item.category === active);

    return (
        <>
            <section
                style={{
                    padding: "110px 20px",
                    background:
                        "linear-gradient(180deg,#fff,#fff7f7,#fff)",
                    position: "relative",
                    overflow: "hidden",
                }}
            >
                {/* Background Glow */}
                <div
                    style={{
                        position: "absolute",
                        width: "450px",
                        height: "450px",
                        borderRadius: "50%",
                        background: "rgba(232,33,42,.08)",
                        filter: "blur(120px)",
                        top: "-120px",
                        left: "-120px",
                    }}
                />

                <div
                    style={{
                        maxWidth: "1350px",
                        margin: "0 auto",
                        position: "relative",
                        zIndex: 2,
                    }}
                >
                    {/* Heading */}
                    <div
                        style={{
                            textAlign: "center",
                            marginBottom: "55px",
                            animation: "fadeUp 1s ease",
                        }}
                    >
                        <span
                            style={{
                                display: "inline-block",
                                padding: "10px 18px",
                                borderRadius: "999px",
                                background: "rgba(232,33,42,.08)",
                                color: "#E8212A",
                                fontWeight: "700",
                                fontSize: "14px",
                                fontFamily:
                                    "'Plus Jakarta Sans', sans-serif",
                                marginBottom: "20px",
                            }}
                        >
                            OUR CATEGORIES
                        </span>

                        <h2
                            style={{
                                fontSize: "58px",
                                lineHeight: "1.1",
                                color: "#111",
                                fontWeight: "800",
                                marginBottom: "18px",
                                textAlign: "center",
                                fontFamily: "'Syne', sans-serif",

                            }}
                        >
                            Explore Our<br />
                            <span style={{ color: "#E8212A" }}>
                                {" "}
                                App Portfolio
                            </span>
                        </h2>

                        <p
                            style={{
                                maxWidth: "760px",
                                margin: "0 auto",
                                color: "#666",
                                lineHeight: "1.8",
                                textAlign: "center",
                                fontSize: "18px",
                                fontFamily:
                                    "'Plus Jakarta Sans', sans-serif",
                            }}
                        >
                            Discover premium mobile applications crafted by
                            AppVerseLabs for startups, enterprises and modern
                            digital brands.
                        </p>
                    </div>

                    {/* Categories */}
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            flexWrap: "wrap",
                            gap: "14px",
                            marginBottom: "60px",
                        }}
                    >
                        {categories.map((item, index) => (
                            <button
                                key={index}
                                onClick={() => setActive(item)}
                                className="category-btn"
                                style={{
                                    padding: "14px 24px",
                                    borderRadius: "999px",
                                    border:
                                        active === item
                                            ? "1px solid #E8212A"
                                            : "1px solid #eee",
                                    background:
                                        active === item
                                            ? "linear-gradient(135deg,#E8212A,#ff4d5a)"
                                            : "#fff",
                                    color:
                                        active === item
                                            ? "#fff"
                                            : "#111",
                                    fontWeight: "700",
                                    fontSize: "15px",
                                    cursor: "pointer",
                                    transition: ".4s ease",
                                    fontFamily:
                                        "'Plus Jakarta Sans', sans-serif",
                                    boxShadow:
                                        active === item
                                            ? "0 12px 30px rgba(232,33,42,.25)"
                                            : "0 6px 20px rgba(0,0,0,.04)",
                                }}
                            >
                                {item}
                            </button>
                        ))}
                    </div>

                    {/* Projects Grid */}
                    <div
                        style={{
                            display: "grid",
                            gridTemplateColumns:
                                "repeat(auto-fit,minmax(320px,1fr))",
                            gap: "28px",
                        }}
                    >
                        {filteredProjects.map((project, index) => (
                            <div
                                key={index}
                                className="portfolio-card"
                                style={{
                                    position: "relative",
                                    borderRadius: "28px",
                                    overflow: "hidden",
                                    height: "430px",
                                    cursor: "pointer",
                                    animation: `fadeScale .7s ${index * 0.15
                                        }s both`,
                                }}
                            >
                                <img
                                    src={project.image}
                                    alt=""
                                    className="portfolio-image"
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                        transition: "1s ease",
                                    }}
                                />

                                {/* Overlay */}
                                <div
                                    style={{
                                        position: "absolute",
                                        inset: 0,
                                        background:
                                            "linear-gradient(to top,rgba(0,0,0,.88),rgba(0,0,0,.1))",
                                    }}
                                />

                                {/* Floating Category */}
                                <div
                                    style={{
                                        position: "absolute",
                                        top: "20px",
                                        left: "20px",
                                        background: "#fff",
                                        color: "#E8212A",
                                        padding: "8px 16px",
                                        borderRadius: "999px",
                                        fontSize: "13px",
                                        fontWeight: "700",
                                        fontFamily:
                                            "'Plus Jakarta Sans', sans-serif",
                                        boxShadow:
                                            "0 8px 24px rgba(0,0,0,.12)",
                                    }}
                                >
                                    {project.category}
                                </div>

                                {/* Content */}
                                <div
                                    style={{
                                        position: "absolute",
                                        bottom: "28px",
                                        left: "28px",
                                        right: "28px",
                                        color: "#fff",
                                    }}
                                >
                                    <h3
                                        style={{
                                            fontSize: "34px",

                                            marginBottom: "14px",
                                            fontFamily:
                                                "'Syne', sans-serif",
                                        }}
                                    >
                                        {project.title}
                                    </h3>

                                    <NavLink
                                        to={`/portfolio/${project.slug}`}
                                        style={{
                                            display: "inline-block",
                                            textDecoration: "none",
                                            background: "linear-gradient(135deg,#E8212A,#ff4d5a)",
                                            color: "#fff",
                                            padding: "14px 24px",
                                            borderRadius: "14px",
                                            fontWeight: "700",
                                            fontSize: "14px",
                                            fontFamily: "'Plus Jakarta Sans', sans-serif",
                                        }}
                                    >
                                        View Project →
                                    </NavLink>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* CSS */}
                <style>{`

                    @keyframes fadeUp{
                        from{
                            opacity:0;
                            transform:translateY(60px);
                        }
                        to{
                            opacity:1;
                            transform:translateY(0);
                        }
                    }

                    @keyframes fadeScale{
                        from{
                            opacity:0;
                            transform:translateY(40px) scale(.95);
                        }
                        to{
                            opacity:1;
                            transform:translateY(0) scale(1);
                        }
                    }

                    .portfolio-card{
                        box-shadow:0 15px 45px rgba(0,0,0,.08);
                        transition:.5s ease;
                    }

                    .portfolio-card:hover{
                        transform:translateY(-14px);
                        box-shadow:0 25px 70px rgba(232,33,42,.16);
                    }

                    .portfolio-card:hover .portfolio-image{
                        transform:scale(1.08);
                    }

                    .category-btn:hover{
                        transform:translateY(-3px);
                    }

                    @media(max-width:768px){

                        section{
                            padding:40px 18px !important;
                        }

                        h2{
                            font-size:38px !important;
                        }

                        .portfolio-card{
                            height:360px !important;
                            border-radius:22px !important;
                        }

                    }

                `}</style>
            </section>
        </>
    );
};

export default PortfolioCategories;